import { render, staticRenderFns } from "./AiStyleAssets.vue?vue&type=template&id=5bcbefba"
import script from "./AiStyleAssets.vue?vue&type=script&lang=js"
export * from "./AiStyleAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports